<template>
    <div>
        <footer>
            <div class="footer-area">
                <div class="footer-top">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-4 col-lg-4 col-md-6">
                                <div class="footer-widget">
                                    <div class="fw-logo mb-25">
                                        <router-link to="/"><img src="assets/img/logo/logo.png" alt="Apexa" /></router-link>
                                    </div>
                                    <div class="footer-content">
                                        <div class="footer-social">
                                            <ul class="list-wrap">
                                                <li><a href="https://www.facebook.com/drone.dinparkonsel/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                                <li><a href="javascript:void(0)"><i class="fab fa-twitter"></i></a></li>
                                                <li><a href="javascript:void(0)"><i class="fab fa-instagram"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Informasi</h4>
                                    <div class="footer-info-list">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-phone-call"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="javascript:void(0)">+62 852-4175-5802</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-envelope"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="mailto:lpse@konaweselatankab.go.id">lpse@konaweselatankab.go.id</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-pin"></i>
                                                </div>
                                                <div class="content">
                                                    <p>Kompleks Perkantoran Pemerintah Daerah</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                <div class="footer-widget">
                                    <h4 class="fw-title">Top Links</h4>
                                    <div class="footer-link-list">
                                        <ul class="list-wrap">
                                            <li><router-link to="/berita" target="_blank">Berita</router-link></li>
                                            <li><router-link to="/dataPegawai" target="_blank">Data Pegawai</router-link></li>
                                            <li><router-link to="/foto" target="_blank">Foto</router-link></li>
                                            <li><router-link to="/video" target="_blank">Video</router-link></li>
                                            <li><router-link to="/skm">SKM</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-7 order-0 order-lg-2">
                                
                            </div>
                            <div class="col-lg-5">
                                <div class="copyright-text">
                                    <p>Copyright © <a href="javascript:void(0)">Diskominfosandi & LPSE</a> | All Right Reserved</p>
                                    <a href="javascript:void(0)">Support Terms & Conditions Privacy Policy.</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-shape">
                    <img class="dark-opacity" src="assets/img/images/footer_shape01.png" alt="Apexa" data-aos="fade-right" data-aos-delay="400" />
                    <img class="dark-opacity" src="assets/img/images/footer_shape02.png" alt="Apexa" data-aos="fade-left" data-aos-delay="400" />
                    <img src="assets/img/images/footer_shape03.png" alt="Apexa" data-parallax='{"x" : 100 , "y" : -100 }' />
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {

            id: "",
            list_foto: [],
            unit_kerja: this.$store.state.UNIT_KERJA,

            file_path: this.$store.state.url.URL_APP + "uploads/",
            galeryku: {
                id: '',
                judul: '',
                deskripsi: '',
                file: '',
                unit_kerja: '',
                status: '',
                createBy: '',
                createAt: '',
            },
        }
    },


    methods: {
        getFoto: function () {
            fetch(this.$store.state.url.URL_FOTO, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                },
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_foto = res_data
                    // console.log(res_data);
                });
        },

        selectDataFoto: function (data) {
            this.galeryku = {
                id: data.id,
                judul: data.judul,
                deskripsi: data.deskripsi,
                file: data.file,
                unit_kerja: data.unit_kerja,
                status: data.status,
                createBy: data.createBy,
                createAt: data.createAt,
            };
            // console.log(data);
        },
    },


    mounted() {
        this.getFoto();
    },
}
</script>

<style></style>